import {HandleSubmit} from '../../func/HandleSubmit';

async function DeleteGroup(group_code) {
    const SendParameters = {
        detail: {
            group_code: group_code,
        }
    };
    console.log("SendParameters",SendParameters);
    var response_info = await HandleSubmit('group/delete', SendParameters);
    if (response_info.status.trim() === "OK") {
        alert("حذف گردید");
    }
    else {
        alert("مشکل در حذف");
    }
}
export default (DeleteGroup);




// WEBPACK FOOTER //
// ./src/pages/Group/DeleteGroup.js